<div class="toggle">
    <label [attr.for]="inputId"
           [class.is-checked]="checked"
           [class.is-disabled]="disabled"
           #label>

        <input #input
               class="visually-hidden"
               [id]="inputId"
               type="checkbox"
               [required]="required"
               [checked]="checked"
               [attr.value]="value"
               [disabled]="disabled"
               [attr.name]="name"
               [attr.aria-label]="ariaLabel || null"
               [attr.aria-labelledby]="ariaLabelledby"
               [attr.aria-checked]="getAriaChecked()"
               (click)="onInputChange($event)">

        <i [class.icon-toggle]="!checked"
           aria-hidden="true"></i>

        <span class="toggle__body">
            <ng-content />
        </span>
    </label>
</div>